import React from 'react'

function Icon() {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='16'
      fill='none'
      viewBox='0 0 16 16'
    >
      <path
        fill='#202020'
        fillOpacity='0.5'
        d='M8 2a7.336 7.336 0 017.212 6A7.336 7.336 0 01.787 8 7.336 7.336 0 018 2zm0 10.667A6.004 6.004 0 0013.85 8 6.003 6.003 0 002.148 8 6.003 6.003 0 008 12.667zM8 11a3 3 0 110-6 3 3 0 010 6zm0-1.333a1.667 1.667 0 100-3.334 1.667 1.667 0 000 3.334z'
      ></path>
    </svg>
  )
}

export default Icon
